import type { FC } from "react"

import { studioToScreen } from "@logic/lib/design"
import { useRecoilValue } from "recoil"

import {
  panelSelectionSnapPointsState,
  panelSelectionState,
} from "../../../state/elements/panels"
import { zoomState } from "../../../state/view"

const SelectionSnapPoints: FC = () => {
  const selectionSnapPoints = useRecoilValue(panelSelectionSnapPointsState)
  const panelIdSelection = useRecoilValue(panelSelectionState)
  const zoom = useRecoilValue(zoomState)

  return (
    <>
      {panelIdSelection.size &&
        selectionSnapPoints.map((snapPoint, idx) => {
          const screenPoint = studioToScreen.point(snapPoint, zoom)

          return (
            <circle
              key={JSON.stringify(snapPoint) + idx}
              cx={screenPoint.x}
              cy={screenPoint.y}
              r="5"
              fill="red"
            />
          )
        })}
    </>
  )
}

export default SelectionSnapPoints
